import actions from "./actions";
import uniq from 'lodash/uniq';
import uniqBy from 'lodash/uniqBy';
import {transformer} from '@web/lib/parse';
import {auth} from '@web/lib/firebase';

const tableData = ({objectPath: key, ...data}, collection) => {
  return transformer(collection)
  .flatten("", {
    ...data, key,
  });
};

export const transformCollectionPayload = (items, collection = {}) => {
  console.log("items:", items, collection);
  return items
  ?.filter(Boolean)
  ?.reduce(($acc, item) => {
    const data = item.ref ?
      {...item.data(), objectID: item.id, objectPath: item.ref.path} :
      item;
    $acc.list.push(data.objectPath);
    $acc.data[data.objectPath] = data;
    $acc.table.push(tableData(data, collection));
    return $acc;
  }, {list: [], data: {}, table: []});
}

const initState = {
  isLoading: false,
  errorMessage: false,
  data: {},
  startTime: new Date().getTime(),
};

/**
 * @summary Reducer for apps
 * @param {object} state
 * @param {string} type
 * @param {{
 *  data: FirestoreQueryItems,
 * }} payload
 * @param {string} collection
 * @return {*}
 */
export default function reducer(state = initState, {type, payload, data, action, pageToken, lists, selectedPaths, collectionId, ts, basePath, error}) {
  switch (type) {
    case actions.SET_BASE_PATH:
      return {
        ...state,
        basePath,
      };
    case actions.FETCH_SUCCESS: {
      if (!data.items?.length) {
        console.log("data.items is empty:", data);
        return state;
      }
      const payload = transformCollectionPayload(data.items, data.collection);
      return {
        ...state,
        data: {...state.data || null, ...payload.data},
        [action.collectionId]: {
          ...(state[action.collectionId] || null),
          table: uniqBy([...state[action.options.path]?.table || [], ...payload.table], "key"),
          list: uniq([...state[action.options.path]?.list || [], ...payload.list]),
          pageToken,
          hasNew: action.pageToken ?
            state[action.collectionId].hasNew :
            null,
          collection: data.collection,
        },
      }
    }
    case actions.SYNC_COLLECTION_SUCCESS: {
      const collectionsPath = ["user", auth.currentUser.uid, "collections", collectionId].join("/");
      return {
        ...state,
        data: {...state.data || null, ...payload.data},
        [collectionId]: {
          ...state[collectionId] || null,
          items: [...state[collectionId]?.items || [], ...payload.items || []],
          list: [...state[collectionId]?.list || [], ...payload.list],
          table: Object
          .entries(payload.data)
          .map(([path, value]) => {
            return tableData({
              ...value,
              objectPath: path,
              objectID: collectionId + "/" + path.split("/").pop()},
              payload.data[collectionsPath] || state.data?.[collectionsPath] || {},
            );
          }),
          hasNew: {
            count: (state[collectionId]?.hasNew?.count ?? 0) + 1,
            timestamp: new Date().getTime(),
          },
          syncError: null,
        },
      };
    }
    case actions.SYNC_COLLECTION_ERROR: {
      return {
        ...state,
        [collectionId]: {
          ...state[collectionId] || null,
          syncError: payload || error,
        },
      };
    }
    case actions.SET_SELECTED_PATHS: {
      return {
        ...state,
        selectedPaths: {
          ...state.selectedPaths,
          [collectionId]: uniq([...selectedPaths || []]),
        },
      };
    }
    case actions.CHANNEL_UNSUBSCRIBE_SUCCESS: {
      const {collectionId} = payload;
      if (!collectionId) {
        return state;
      }
      return {
        ...state,
        [collectionId]: {
          ...state[collectionId] || null,
          hasNew: false,
          syncError: null,
        },
      };
      // const newState = {...state};
      // if (newState[collectionId]) {
      //   delete newState[collectionId];
      // }
      // return newState;
    }
    // case actions.UPDATE_COLLECTIONS_LIST: {
    //   return {
    //     ...state,
    //     lists: {
    //       ...state.lists,
    //       ...lists,
    //     },
    //   };
    // }
    // case actions.CHANNEL_SUBSCRIBE_SUCCESS: {
    //   console.log("CHANNEL_SUBSCRIBE_SUCCESS:", payload);
    //   return {
    //     ...state,
    //     // [action.collectionId]: {
    //     //   ...state[action.collectionId] || null,
    //     //   subscribed: ts,
    //     //   error: null,
    //     // },
    //   };
    // }
    // case actions.CHANNEL_UNSUBSCRIBE_SUCCESS: {
    //   console.log("CHANNEL_UNSUBSCRIBE_SUCCESS:", payload);
    //   return {
    //     ...state,
    //     // [action.collectionId]: {
    //     //   ...state[action.collectionId] || null,
    //     //   subscribed: false,
    //     // },
    //   };
    // }
    default:
      return state;
  }
}
